module.exports = __webpack_public_path__ + "static/media/Portrait-10239.523c0b96.jpg";